// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"910aab82","239":"bc1bc257","667":"210c0a5e"}[chunkId] + ".chunk.js";
};